import { withResetState } from "store/hocs";

import { feeTemplateConstants } from "./feeTemplate.constants";
import {
	newErrorState,
	newRequestState,
	newSuccessState,
} from "../../common/baseReducers";

const initialState = {
	error: {
		template: null,
	},
	loading: {
		template: false,
	},
	template: null,
};

function feeTemplate(state = initialState, action) {
	switch (action.type) {
		case feeTemplateConstants.GET_FEE_TEMPLATE_REQUEST:
			return newRequestState(state, "template");
		case feeTemplateConstants.GET_FEE_TEMPLATE_SUCCESS:
			return newSuccessState(state, "template", action.template);
		case feeTemplateConstants.GET_FEE_TEMPLATE_ERROR:
			return newErrorState(state, "template", action.error);

		case feeTemplateConstants.EDIT_FEE_TEMPLATE_REQUEST: {
			return {
				...state,
				error: {
					template: null,
				},
				loading: {
					template: true,
				},
			};
		}

		case feeTemplateConstants.PURGE_ACTIVE_FEE_TEMPLATE:
			return {
				...state,
				error: {
					template: null,
				},
				loading: {
					template: false,
				},
				template: null,
			};

		default:
			return state;
	}
}

export default withResetState({ initialState })(feeTemplate);
